<div class="ziro-admin-page-content">
  <ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>

  <div class="col-md-10 offset-md-1 pb-2" [hidden]="isLoading">
    <ziro-breadcrumbs>
      <ziro-breadcrumb-card-item>
        <div [innerHtml]="'tkey;admin.device.utilization.settings.description' | escapeHtml"></div>
      </ziro-breadcrumb-card-item>
    </ziro-breadcrumbs>

    <div class="mb-3 list-group list-group-striped border-rad-all-12 card-shadow">
      @for (config of formConfig.fields | keyvalue: returnZero; track config) {
        <div class="list-group-item position-relative">
          <ziro-general-settings-text [fieldId]="config.key"></ziro-general-settings-text>
        </div>
      }
    </div>
  </div>
</div>

<ziro-bottom-nav></ziro-bottom-nav>
